export default function icon (description){
    const lowerDesc = description.toLowerCase();
  
    if (lowerDesc.includes('café') || lowerDesc.includes('cafe') || lowerDesc.includes('cafeteria')) {
      return 'CoffeeIcon';
    } else if (lowerDesc.includes('comida') || lowerDesc.includes('delicatessen') || lowerDesc.includes('restaurante')) {
      return 'LocalDiningIcon';
    } else if (lowerDesc.includes('pizza') || lowerDesc.includes('rápidas') || lowerDesc.includes('fast food')) {
      return 'LocalPizzaIcon' ;
    } else if (lowerDesc.includes('cerveza') || lowerDesc.includes('licor') || lowerDesc.includes('bar') || lowerDesc.includes('bebida')) {
      return 'LiquorIcon';
    } else if (lowerDesc.includes('menú') || lowerDesc.includes('set')) {
      return 'SetMealIcon';
    } else if (lowerDesc.includes('helado') || lowerDesc.includes('postre') || lowerDesc.includes('ice cream')) {
      return 'IcecreamIcon';
    } else if (lowerDesc.includes('sopa') || lowerDesc.includes('caliente')) {
      return 'SoupKitchenIcon';
    } else if (lowerDesc.includes('pan') || lowerDesc.includes('bakery') || lowerDesc.includes('dining')) {
      return 'BakeryDiningIcon';
    } else if (lowerDesc.includes('automotor') || lowerDesc.includes('vehículo') || lowerDesc.includes('vehiculo')) {
      return 'DirectionsCarIcon';
    } else if (lowerDesc.includes('jugo') || lowerDesc.includes('exprimido') || lowerDesc.includes('licuado')) {
      return 'BlenderIcon';
    } else if (lowerDesc.includes('premium') || lowerDesc.includes('deli')) {
      return 'WorkspacePremiumIcon';
    } else if(lowerDesc.includes('combo') || lowerDesc.includes('burg')) {
      return 'LunchDiningIcon';
    } else if (lowerDesc.includes('kiosco')) {
      return 'CookieIcon';
    } else if (lowerDesc.includes('favorito') || lowerDesc.includes('promo')) {
      return 'StarIcon';
    } else {
      return 'HelpIcon'; // Ícono por defecto
    }
  };